exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobile-config[data-v-42760b98]{height:63px;padding:0 15px;line-height:63px}.mobile-config .title-bar[data-v-42760b98]{font-size:16px;color:#333;font-family:PingFang SC-Medium,PingFang SC;font-weight:600}.radio-boxs[data-v-42760b98]{width:140px;height:28px;cursor:pointer;background:#f9f9f9;border-radius:14px 14px 14px 14px;margin-top:17px;opacity:1;font-size:12px;color:#333}.radio-boxs .btn[data-v-42760b98]{width:70px;height:28px;text-align:center;line-height:28px}.radio-boxs .active[data-v-42760b98]{background:var(--prev-color-primary);border-radius:14px 14px 14px 14px;opacity:1;color:#fff}", ""]);

// exports
